import React, { useState } from "react";
import "../styles/menu.css";
import { motion} from "framer-motion";
import { settingIcon, starSolidIcon, listIcon, photoIcon } from "./Icons";


const variants = {
  open: { height: "300px" },
  closed: { height: "60px" },
};

function Menu(props) {
  const {viewStore, setViewStore, settingDialog, setSettingDialog, openImageDialog, setOpenImageDialog, width} = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="menu-container">
      <motion.div
        className="menu-body"
        animate={isOpen ? "open" : "closed"}
        variants={variants}
        drag
        dragConstraints={{ left: -30, right: width-110, top: -450, bottom: 90}}
        dragElastic={0.2}
      >
        <div className="menu-structure">
            {viewStore ? 
            <div className="menu-item" onClick={() => setViewStore(false)}>{listIcon}<h5 className="noselect">All CSI</h5></div>:
            <div className="menu-item" onClick={() => setViewStore(true)}>{starSolidIcon}<h5 className="noselect">Stored CSI</h5></div>
            }
          <div className="menu-item" onClick={() => setOpenImageDialog(!openImageDialog)}>{photoIcon}<h5>By Image</h5></div>
          <div className="menu-item" onClick={() => setSettingDialog(!settingDialog)}>{settingIcon}<h5>Settings</h5></div>
          <div className="menu-handle noselect">{listIcon}</div>
          <motion.div
            className="menu-toggle"
            onClick={() => setIsOpen(!isOpen)}
          >
            <MenuToggle isOpen={isOpen} setIsOpen={setIsOpen} />
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}

export default Menu;

const Path = (props) => (
  <motion.path
    fill="transparent"
    strokeWidth="3"
    stroke="hsl(66.0576923076923, 82.53968253968253%, 49.411764705882355%)"
    strokeLinecap="round"
    {...props}
  />
);

const MenuToggle = ({ isOpen, setIsOpen }) => (
  <div className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
    <svg width="23" height="23" viewBox="0 0 23 23">
      <Path
        variants={{
          closed: { d: "M 11.5 0 L 11.5 23" },
          open: { d: "M 3 16.5 L 17 2.5" },
        }}
      />
      <Path
        //d="M 2 9.423 L 20 9.423"
        d="M 11.5 0 L 11.5 20"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 },
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        variants={{
          closed: { d: "M 0 11 L 23 11" },
          open: { d: "M 3 2.5 L 17 16.346" },
        }}
      />
    </svg>
  </div>
);